import { STORAGE_KEYS } from '@/constants/appIdentity'

const GATE_CB_PATTERN = /^\d{13}-[a-fA-F0-9]{6,8}$/
const GATE_CB_SESSION_KEY = STORAGE_KEYS.gateCb

function randomHex(length = 6) {
  const size = Math.max(1, Number(length) || 6)
  const bytes = new Uint8Array(Math.ceil(size / 2))
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, size)
}

export function generateGateCb() {
  return `${Date.now()}-${randomHex(6)}`
}

export function isValidGateCb(value) {
  const cb = Array.isArray(value) ? value[0] : value
  return GATE_CB_PATTERN.test(String(cb || ''))
}

export function getOrCreateGateCb() {
  try {
    const saved = sessionStorage.getItem(GATE_CB_SESSION_KEY)
    if (isValidGateCb(saved)) return saved
  } catch (e) {
    // ignore
  }
  const next = generateGateCb()
  try {
    sessionStorage.setItem(GATE_CB_SESSION_KEY, next)
  } catch (e) {
    // ignore
  }
  return next
}

export function ensureGateCbOnAddressBar(path) {
  if (path === '/kfchat.html' || String(path || '').startsWith('/kfchat')) return

  const url = new URL(window.location.href)
  if (isValidGateCb(url.searchParams.get('cb'))) return

  url.searchParams.set('cb', getOrCreateGateCb())
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`
  )
}

/** 邀请注册链接：cb 放在 search（History 模式可读，门禁也能读到） */
export function buildInviteRegisterUrl(webDomain, invitationCode) {
  const base = String(webDomain || window.location.origin).replace(/\/$/, '')
  const code = String(invitationCode || '').trim()
  if (!code) return ''
  const cb = generateGateCb()
  const params = new URLSearchParams({ invitation_code: code, cb })
  return `${base}/register?${params.toString()}`
}

/** 同时读 route.query 与 location.search（hash 前参数） */
export function getSearchParam(name, routeQuery = {}) {
  const fromRoute = routeQuery?.[name]
  if (fromRoute != null && String(fromRoute).trim() !== '') {
    return Array.isArray(fromRoute) ? String(fromRoute[0]) : String(fromRoute)
  }
  try {
    return new URLSearchParams(window.location.search).get(name) || ''
  } catch (e) {
    return ''
  }
}
